import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import List from "devextreme-react/list";
import useHandleNotifications from "../../Hooks/useHandleData/useHandleNotifications";
import SantaFlyover from "./Components/santaFlyover";
import useGetWorkCenterBackground from "../../Hooks/useGET/useGetWorkCenterBackground";
import "./styles.css";
import {
  getUsersName,
  getUsersWAauth,
  getUsersRoles,
  checkRoles,
} from "../../Utils/helper";
import useAuth from "../../Hooks/useAuth";
import logos from "../../Assets/images/NIRAATLASLogo.png";
import NavBar from "../../Components/Navbar";
import SideNav from "../../Components/Navbar/SideNavBar";
import Snowfall from "react-snowfall";

// new font source https://ionic.io/ionicons
// dev extreme https://js.devexpress.com/React/Documentation/guide/themes_and_styles/icons/

export default function PortalPage({ props }) {
  const [isVisible, setVisibility] = useState(true);
  const { notificationsData } = useHandleNotifications(),
    auth = useAuth(),
    navigate = useNavigate(),
    [notifications, setNotifications] = useState([]);
  //[maxHeight, setMaxHeight] = useState(0),
  //[nav1, setNav1] = useState(),
  //[nav2, setNav2] = useState();
  const [bgUrl, setBgUrl] = useState(null);
  const { backgroundUrl } = useGetWorkCenterBackground();

  const GreetingsText = () => {
    const hourOfDay = new Date().getHours();

    if (hourOfDay >= 6 && hourOfDay < 12) {
      return "Good morning";
    } else if (hourOfDay >= 12 && hourOfDay < 18) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };

  useEffect(() => {
    if (notificationsData) {
      setNotifications(notificationsData);
    }
  }, [notificationsData]);

  useEffect(() => {
    if (!backgroundUrl) return;
    let alive = true;
    const img = new Image();
    img.onload = () => {
      if (alive) setBgUrl(backgroundUrl);
    };
    img.onerror = (e) => {
      console.warn("BG preload failed:", backgroundUrl, e);
    };
    img.src = backgroundUrl;
    return () => {
      alive = false;
    };
  }, [backgroundUrl]);

  const listLinks = (e) => {
    return (
      <div
        className="row row-cols-auto"
        style={{ alignItems: "center", padding: "0px" }}
        onClick={() => {
          navigate(e.link);
        }}
      >
        <div className="dashPillLogoWrapperSmall flexBoxCCC">
          <ion-icon name={e.icon}></ion-icon>
        </div>
        <h5 className="portalItemName noBold">{e.name}</h5>
      </div>
    );
  };
  const visibleOptions = props.options.filter((opt) => {
    if (opt.name === "Locations" && !checkRoles(5)) {
      return false;
    }
    return opt.restriction;
  });
  const columnCount = Math.min(visibleOptions.length, 6); // max 6 columns
  const ScrollList = ({ items, renderItem }) => {
    const ref = useRef();
    const [showDown, setShowDown] = useState(false);
    const [showUp, setShowUp] = useState(false);

    useEffect(() => {
      if (!ref.current) return;

      const el = ref.current;
      if (items.length > 3) {
        setShowDown(true);
      }

      const handleScroll = () => {
        setShowUp(el.scrollTop > 0);
        setShowDown(el.scrollTop + el.clientHeight < el.scrollHeight);
      };

      el.addEventListener("scroll", handleScroll);
      return () => el.removeEventListener("scroll", handleScroll);
    }, [items]);

    const scrollDown = () =>
      ref.current.scrollBy({ top: 80, behavior: "smooth" });
    const scrollUp = () =>
      ref.current.scrollBy({ top: -80, behavior: "smooth" });

    return (
      <div className="scroll-wrapper">
        <div className="scroll-content" ref={ref}>
          {items.map((x, i) => (
            <div key={i} className="scroll-item">
              {renderItem(x)}
            </div>
          ))}
        </div>

        {showDown && (
          <div className="scroll-arrow down" onClick={scrollDown}>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </div>
        )}

        {showUp && (
          <div className="scroll-arrow up" onClick={scrollUp}>
            <ion-icon name="chevron-up-outline"></ion-icon>
          </div>
        )}
      </div>
    );
  };

  const today = new Date();
  const month = today.getMonth(); // 0 = Jan, 11 = Dec
  const day = today.getDate();

  const isHolidayMode = month === 11 && day >= 16 && day <= 31;

  return (
    <>
      {isHolidayMode && (
        <>
          <SantaFlyover />
        </>
      )}
      <div className="portalContainer">
        <div
          className={`inner ${bgUrl ? "" : "fallback"}`}
          style={bgUrl ? { backgroundImage: `url(${bgUrl})` } : undefined}
        >
          <div className="overlay" />
          <NavBar>
            <SideNav isVisible={false} />
          </NavBar>

          <div className="full-height">
            <div className="px-lg-5 px-3">
              <div id="filler" />
              <div className="row my-md-2 my-6 header">
                <h1 className="white px-3 greeting">
                  {props.heading
                    ? props.heading
                    : `${GreetingsText()}, ${getUsersName()}`}
                </h1>
              </div>
              <div className="row top-section">
                <div className="col-6 d-flex mb-5 justify-content-center justify-content-md-start">
                  <img src={logos} alt="NIAR Logo and ATLAS Logo" width={500} />
                </div>
                <div className="col-6 d-flex mb-5 justify-content-end align-items-center">
                  {visibleOptions
                    .filter(
                      (opt) =>
                        opt.name === "Users" || opt.name === "View My Hours",
                    )
                    .map((opt, i) => (
                      <div className="col" key={i}>
                        {opt.name === "Users" ? (
                          <div className="dashLabPill flexBoxCCC target row-cols-auto">
                            <div className="portalTitle ms-4">
                              <h3 className="mb-0 yellow">{opt.name}</h3>
                              <div className="row row-cols-auto ms-5">
                                {opt.list.map((item, index) => (
                                  <div
                                    className="col grid-tag"
                                    key={index}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(item.link)}
                                  >
                                    <div className="my-2">
                                      <div className="row row-cols-auto align-items-center mx-3">
                                        <div className="dashPillLogoWrapperSmall flexBoxCCC">
                                          <ion-icon name={item.icon}></ion-icon>
                                        </div>
                                        <h5 className="portalItemName noBold ">
                                          {item.name}
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Link
                            to={opt.link}
                            className="dashLabPill flexBoxCsCC target"
                            style={{
                              height: "160px",
                              minWidth: "500px",
                            }}
                          >
                            <div className="portalTitle ms-5">
                              <h3 className="yellow">{opt.name}</h3>
                              <div className="dashPillLogoUser flexBoxCCC">
                                <ion-icon name={opt.icon}></ion-icon>
                              </div>
                            </div>
                          </Link>
                        )}
                      </div>
                    ))}
                </div>

                <div className="row">
                  {visibleOptions
                    .filter(
                      (opt) =>
                        opt.name !== "Users" && opt.name !== "View My Hours",
                    )
                    .map((opt, i) => (
                      <div className="col" key={i}>
                        {opt.name === "Reports" ||
                        (checkRoles(6) && opt.name === "Projects") ||
                        opt.name === "Locations" ||
                        opt.name === "Business" ? (
                          <div
                            className="dashLabPill flexBoxCCC target"
                            style={{ height: "270px", position: "relative" }}
                          >
                            <h3 className="mb-0 yellow portalName">
                              {opt.name}
                            </h3>

                            {/* REPLACED LIST WITH CUSTOM SCROLL BLOCK */}
                            <ScrollList
                              items={
                                opt.name === "Business"
                                  ? opt.list.filter((item) => item.restriction)
                                  : opt.list
                              }
                              renderItem={(item) => listLinks(item)}
                            />
                          </div>
                        ) : (
                          opt.name !== "Users" && (
                            <Link
                              to={opt.link}
                              className="dashLabPill flexBoxCsCC target"
                              style={{
                                height: checkRoles(1) ? "270px" : "200px",
                              }}
                            >
                              <h3 className="yellow portalName">{opt.name}</h3>
                              <div className="dashPillLogoWrapper flexBoxCCC">
                                <ion-icon name={opt.icon}></ion-icon>
                              </div>
                            </Link>
                          )
                        )}
                      </div>
                    ))}
                  {isHolidayMode && (
                    <div className="col christmas-free">
                      <h3
                        className="yellow portalName mb-2"
                        style={{ textAlign: "center" }}
                      ></h3>

                      <div className="christmas-holiday-wrapper">
                        <div className="christmas-tree-free">🎄</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
